const config = {
  showGuidedFormOnly: process.env.REACT_APP_SHOW_GUIDED_FORM_ONLY === "true",
};

export default config;
